import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportGlobalImage } from 'src/app/_objects/report-template';
import { ReportTemplateService } from 'src/app/_services/report-template.service';
import { StorageService, REPORT_TEMPLATE___APPLICATION_TYPE } from '../../_services/storage.service';
import { CommonDeleteDialogComponent } from '../common-delete-dialog/common-delete-dialog.component';
import { CommonConfirmDialogComponent } from '../common-confirm-dialog/common-confirm-dialog.component';
import { CommonSnackBarService } from 'src/app/_services/common-snack-bar.service';
import { SpinnerService } from '@osc-utils/services/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from 'src/app/_services/lang-update.service';

@Component({
    selector: 'app-report-template-image-upload-dialog',
    styleUrls: ['./report-template-image-upload-dialog.component.scss'],
    templateUrl: './report-template-image-upload-dialog.component.html',
    standalone: false
})
export class ReportTemplateImageUploadDialogComponent implements OnInit {

  templateImages: ReportGlobalImage[];
  fileDisplayName: string;

  @Output() changeImages = new EventEmitter();
  uploadImagePath: string;
  uploadFile: File;
  public isVisol: boolean = false;
  public templateId: string = null;
  usedFileNameList: string[];

  constructor(
    private reportTemplateService: ReportTemplateService,
    private snackBar: CommonSnackBarService,
    private dialog: MatDialog,
    private storageService: StorageService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private langService: LangUpdateService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data)
      this.templateId = data.templateId
    this.langService.prepare(this, this.translate);
  }

  ngOnInit() {
    let applicationType = this.storageService.fetchApplicationType(REPORT_TEMPLATE___APPLICATION_TYPE);
    if (applicationType) {
      this.isVisol = applicationType.IsVisol;
    }

    this.usedFileNameList = this.isVisol ? this.data.usedFileNameList : this.usedFileNameList;
    this.loadTemplateImages();
  }

  loadTemplateImages() {
    this.reportTemplateService.getReportTemplateImages(this.templateId, this.isVisol).subscribe(images => {
      this.templateImages = images;
    },
      error => {
        this.snackBar.open(this.translate.instant('imageuploadDialog.loadtemplateImages'));
        console.log(error);
      },
      () => { });
  }

  selectImage(files: FileList) {
    if (files[0]) {
      this.uploadFile = files.item(0);
      this.fileDisplayName = files.item(0).name;
    }
  }

  uploadImage() {
    this.spinnerService.show(this.spinnerService.mainSpinnerId);
    this.reportTemplateService.addReportTemplateImage(this.uploadFile, this.templateId, this.isVisol).subscribe(
      () => { },
      () => {
        this.spinnerService.hide(this.spinnerService.mainSpinnerId);
        this.snackBar.open(this.translate.instant('imageuploadDialog.uploadImage_error'));
      },
      () => {
        this.uploadImagePath = null;
        this.uploadFile = null;
        this.fileDisplayName = null;
        this.changeImages.emit();
        this.loadTemplateImages();
        this.spinnerService.hide(this.spinnerService.mainSpinnerId);
        this.snackBar.open(this.translate.instant('imageuploadDialog.uploadImage_complete'));
      }
    );
  }

  openConfirmDialog(): void {
    const dialogRef = this.dialog.open(CommonConfirmDialogComponent, {
      width: '700px',
      height: '230px',
      data: {
        firstMessage: this.translate.instant('imageuploadDialog.openConfirmDialog'),
        secondMessage: '',
        cancellable: false
      }
    });
  }

  deleteImage(file: ReportGlobalImage) {
    if (!this.isVisol || this.usedFileNameList.indexOf(file.name) === -1) {
      const dialogRef = this.dialog.open(CommonDeleteDialogComponent, {
        width: '600px',
        minWidth: '400px',
        maxHeight: '800px',
        data: { target: this.translate.instant('imageuploadDialog.templateImage'), deleteNames: [file.name] }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.deleteImageSub(file);
        }
      });
    } else {
      this.openConfirmDialog();
    }
  }

  deleteImageSub(file: ReportGlobalImage) {
    this.spinnerService.show(this.spinnerService.mainSpinnerId);
    this.reportTemplateService.deleteReportTemplateImage(file.id, file.name, this.isVisol, this.templateId).subscribe(
      res => { },
      error => {
        this.spinnerService.hide(this.spinnerService.mainSpinnerId);
        this.snackBar.open(this.translate.instant('imageuploadDialog.deleteImageSub_error'));
        console.log(error);
      },
      () => {
        this.changeImages.emit();
        this.loadTemplateImages();
        this.spinnerService.hide(this.spinnerService.mainSpinnerId);
        this.snackBar.open(this.translate.instant('imageuploadDialog.deleteImageSub_complete'));
      }
    );
  }
}
